/**
 * Development Logger Utility
 * Provides color-coded, styled console logging for development mode.
 */

const STYLES = {
    badge: 'padding: 2px 6px; border-radius: 3px; font-weight: bold; font-size: 11px;',
    theme: 'background: #3b82f6; color: #ffffff;',
    barba: 'background: #8b5cf6; color: #ffffff;',
    init: 'background: #10b981; color: #ffffff;',
    destroy: 'background: #ef4444; color: #ffffff;',
    skip: 'background: #6b7280; color: #ffffff;',
    disabled: 'background: #f59e0b; color: #ffffff;',
    error: 'background: #dc2626; color: #ffffff;',
    warn: 'background: #f59e0b; color: #ffffff;',
    time: 'color: #9ca3af; font-size: 11px;'
};

export class Logger {
    constructor(isDebug = false) {
        this.enabled = isDebug;
    }

    logInit(name, container, durationMs = null) {
        if (!this.enabled) return;
        const timeStr = durationMs !== null ? `%c (${durationMs.toFixed(2)}ms)` : '';
        console.log(
            `%cTheme%c %cInit%c ${name}${timeStr}`,
            `${STYLES.badge} ${STYLES.theme}`,
            '',
            `${STYLES.badge} ${STYLES.init}`,
            'font-weight: bold; color: #10b981;',
            timeStr ? STYLES.time : ''
        );
    }

    logDestroy(name, durationMs = null) {
        if (!this.enabled) return;
        const timeStr = durationMs !== null ? `%c (${durationMs.toFixed(2)}ms)` : '';
        console.log(
            `%cTheme%c %cDestroy%c ${name}${timeStr}`,
            `${STYLES.badge} ${STYLES.theme}`,
            '',
            `${STYLES.badge} ${STYLES.destroy}`,
            'font-weight: normal; color: #9ca3af;',
            timeStr ? STYLES.time : ''
        );
    }

    logSkip(name, reason = 'No elements found') {
        if (!this.enabled) return;
        console.log(
            `%cTheme%c %cSkipped%c ${name} %c(${reason})`,
            `${STYLES.badge} ${STYLES.theme}`,
            '',
            `${STYLES.badge} ${STYLES.skip}`,
            'color: #6b7280;',
            'color: #9ca3af; font-style: italic;'
        );
    }

    logDisabled(name) {
        if (!this.enabled) return;
        console.log(
            `%cTheme%c %cDisabled%c ${name} (Feature flag is false)`,
            `${STYLES.badge} ${STYLES.theme}`,
            '',
            `${STYLES.badge} ${STYLES.disabled}`,
            'color: #f59e0b;'
        );
    }

    log(tag, message, ...args) {
        if (!this.enabled) return;
        console.log(
            `%c${tag}%c ${message}`,
            `${STYLES.badge} ${STYLES.theme}`,
            'font-weight: normal;',
            ...args
        );
    }

    warn(tag, message, ...args) {
        if (!this.enabled) return;
        console.warn(
            `%c${tag}%c ${message}`,
            `${STYLES.badge} ${STYLES.warn}`,
            'font-weight: normal;',
            ...args
        );
    }

    logError(name, error) {
        console.error(
            `%cTheme%c %cError%c Module "${name}" thrown an exception:`,
            `${STYLES.badge} ${STYLES.theme}`,
            '',
            `${STYLES.badge} ${STYLES.error}`,
            'font-weight: bold;',
            error
        );
    }

    group(title, callback) {
        if (!this.enabled) {
            callback();
            return;
        }
        console.groupCollapsed(`%c[Theme Dev Log] ${title}`, 'color: #3b82f6; font-weight: bold;');
        const startTime = performance.now();
        callback();
        const duration = (performance.now() - startTime).toFixed(2);
        console.log(`%cCompleted in ${duration}ms`, STYLES.time);
        console.groupEnd();
    }
}
